/**
 * @deprecated This enum is deprecated and should not be used in new code.
 * Use VisitorBlocks from constants-visitor-management instead.
 * @see libs/constants/visitor-management
 */
export enum VisitorBlocks {
  Visitors = 'visitors',
  Schedule = 'schedule',
  HostInformation = 'hostInformation',
  Notes = 'notes',
}
